import type React from 'react';
import { connect } from 'react-redux';
import { PaymentCard } from '@lt/components';
import { getIsMobile } from 'src/store/view/selectors';
import { getCardData } from '../../../../../../store/payment/selectors';
import {
  setCardDataAction,
  setCardValidityAction,
} from '../../../../../../store/payment/reducer';

type CardFields = {
  number: string;
  expMonth: string;
  expYear: string;
  cvv: string;
};

interface StateProps {
  defaultValue?: CardFields;
  isMobile: boolean;
}

interface DispatchProps {
  onChange: (cardFields: CardFields) => void;
  onValidationChanged: (isValid: boolean) => void;
}

interface OwnProps {
  showPaymentIcon: boolean;
  validateMIRCard?: boolean;
  TooltipFooter?: React.ReactNode;
}

const mapStateToProps = (state) => ({
  defaultValue: getCardData(state) || undefined,
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  onChange: setCardDataAction,
  onValidationChanged: setCardValidityAction,
};

export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentCard);
